module.exports = __webpack_public_path__ + "static/media/apple.15b0f130.svg";